import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

const ProjectModal = ({ isOpen, closeModal, project }) => {
  if (!project) return null;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0"
            style={{ background: "rgba(5, 10, 14, 0.85)", backdropFilter: "blur(8px)" }}
            aria-hidden="true"
          />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100 translate-y-0"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <Dialog.Panel className="w-full max-w-xl overflow-hidden rounded-2xl text-left font-mono" style={{ background: "rgba(8, 18, 32, 0.95)", border: "1px solid rgba(0,255,153,0.25)", boxShadow: "0 24px 64px rgba(0,0,0,0.7), 0 0 40px rgba(0,255,153,0.06)" }}>
              {/* Top accent */}
              <div className="h-px w-full" style={{ background: "linear-gradient(90deg, transparent, #00ff99, #06b6d4, transparent)" }} />

              <div className="p-6">
                {/* Header */}
                <div className="flex items-start justify-between mb-5">
                  <Dialog.Title className="text-lg font-bold text-slate-100 leading-snug pr-4">
                    {project.title}
                  </Dialog.Title>
                  <button
                    onClick={closeModal}
                    className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-md text-slate-500 hover:text-cyan-200 hover:bg-cyan-500/10 transition-all duration-200 text-lg leading-none"
                  >
                    &times;
                  </button>
                </div>

                {/* Description */}
                <p className="text-sm text-slate-300/85 leading-relaxed mb-5">
                  {project.description}
                </p>

                {/* Tags */}
                {project.tags && (
                  <div className="flex flex-wrap gap-1.5 mb-5">
                    {project.tags.map((tag) => (
                      <span key={tag} className="tech-badge">{tag}</span>
                    ))}
                  </div>
                )}

                {/* Image */}
                {project.image && (
                  <div className="mb-5 rounded-xl overflow-hidden" style={{ border: "1px solid rgba(0,255,153,0.15)" }}>
                    <img src={project.image} alt={project.title} className="w-full object-cover" />
                  </div>
                )}

                {/* Links */}
                <div className="flex gap-4 pt-4" style={{ borderTop: "1px solid rgba(0,255,153,0.1)" }}>
                  {project.link && (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-xs text-cyan-400 hover:text-cyan-300 transition-colors duration-200 group"
                    >
                      <span className="w-5 h-5 rounded flex items-center justify-center" style={{ background: "rgba(6,182,212,0.1)", border: "1px solid rgba(6,182,212,0.2)" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </span>
                      View Live Project
                    </a>
                  )}
                  {project.github && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-xs text-emerald-300 hover:text-emerald-200 transition-colors duration-200"
                    >
                      GitHub Repo &rarr;
                    </a>
                  )}
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ProjectModal;
